import React, { Component } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Calendar, Clock, MapPin, Mail } from 'lucide-react';
import schulungstermine from '../data/schulungstermine.json';
interface TrainingDate {
  date: string;
  time: string;
  location: string;
  spots: number;
  price: number;
}
export function Schulung() {
  const availableDates: TrainingDate[] = schulungstermine;
  const getCoursePrice = (slot: TrainingDate): string => {
    return `${slot.price}€`;
  };
  const isSpecialOffer = (slot: TrainingDate): boolean => {
    return slot.price < 590;
  };
  const parseGermanDate = (dateString: string): Date => {
    const months: {
      [key: string]: number;
    } = {
      Januar: 0,
      Februar: 1,
      März: 2,
      April: 3,
      Mai: 4,
      Juni: 5,
      Juli: 6,
      August: 7,
      September: 8,
      Oktober: 9,
      November: 10,
      Dezember: 11
    };
    const parts = dateString.split(' ');
    const day = parseInt(parts[0].replace('.', ''));
    const month = months[parts[1]];
    const year = parseInt(parts[2]);
    return new Date(year, month, day);
  };
  const isDateInPast = (dateString: string): boolean => {
    const eventDate = parseGermanDate(dateString);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return eventDate < today;
  };
  const handleBooking = (date: string, location: string, price: string) => {
    const subject = encodeURIComponent(`Buchungsanfrage: Schulung "Projektmanagement - der Praxiskurs" am ${date}`);
    const body = encodeURIComponent(`Guten Tag,

ich möchte gerne an der Schulung "Projektmanagement - der Praxiskurs" teilnehmen.

Gewünschter Termin: ${date}
Ort: ${location}
Preis: ${price} + MwSt.

Bitte senden Sie mir weitere Informationen zur Anmeldung und den Teilnahmebedingungen.

Mit freundlichen Grüßen`);
    window.location.href = `mailto:info@ellnerconsult.de?subject=${subject}&body=${body}`;
  };
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 flex flex-col" data-id="element-257">
      <Header forceSolid={true} data-id="element-258" />

      <main className="flex-grow pt-32 pb-24 px-4 sm:px-6 lg:px-8" data-id="element-259">
        <div className="max-w-7xl mx-auto" data-id="element-260">
          {/* Intro Section */}
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-261">
            <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-262">
              Schulung "Projektmanagement - der Praxiskurs"
            </h1>
            <p className="text-xl text-slate-600 leading-relaxed mb-6" data-id="element-263">
              Ein intensiver Tagesworkshop, der Ihnen praxisgerecht die
              wichtigsten Methoden und Werkzeuge des Projektmanagements
              vermittelt.
            </p>

            <ul className="text-left max-w-xl mx-auto space-y-1 mb-6" data-id="element-264">
              <li className="flex items-start text-lg text-slate-600" data-id="element-265">
                <span className="w-2 h-2 bg-blue-500 rounded-full mr-3 mt-2.5 flex-shrink-0" data-id="element-266"></span>
                Kurze Betrachtung der Projektmanagement-Standards
              </li>
              <li className="flex items-start text-lg text-slate-600" data-id="element-267">
                <span className="w-2 h-2 bg-blue-500 rounded-full mr-3 mt-2.5 flex-shrink-0" data-id="element-268"></span>
                Klassisch vs agil
              </li>
              <li className="flex items-start text-lg text-slate-600" data-id="element-269">
                <span className="w-2 h-2 bg-blue-500 rounded-full mr-3 mt-2.5 flex-shrink-0" data-id="element-270"></span>
                Was gehört in eine solide Projektplanung
              </li>
              <li className="flex items-start text-lg text-slate-600" data-id="element-271">
                <span className="w-2 h-2 bg-blue-500 rounded-full mr-3 mt-2.5 flex-shrink-0" data-id="element-272"></span>
                Stakeholder und Risiken
              </li>
              <li className="flex items-start text-lg text-slate-600" data-id="element-273">
                <span className="w-2 h-2 bg-blue-500 rounded-full mr-3 mt-2.5 flex-shrink-0" data-id="element-274"></span>
                Wie halte ich das laufende Projekt auf Kurs?
              </li>
              <li className="flex items-start text-lg text-slate-600" data-id="element-275">
                <span className="w-2 h-2 bg-blue-500 rounded-full mr-3 mt-2.5 flex-shrink-0" data-id="element-276"></span>
                Projektabschluss und was haben wir gelernt?
              </li>
              <li className="flex items-start text-lg text-slate-600" data-id="element-277">
                <span className="w-2 h-2 bg-blue-500 rounded-full mr-3 mt-2.5 flex-shrink-0" data-id="element-278"></span>
                Nützliche Tools
              </li>
            </ul>

            <div className="mt-8 text-center" data-id="element-279">
              <p className="text-xl text-slate-600 leading-relaxed mb-4" data-id="element-280">
                Kein passender Termin dabei? Wir bieten auch individuelle
                Termine für Ihr Team an. Gerne auch auf Englisch oder bei Ihnen
                vor Ort.
              </p>
            </div>
            <div className="flex flex-wrap justify-center gap-4 text-sm text-slate-600" data-id="element-281">
              <div className="flex items-center" data-id="element-282">
                <Clock className="w-4 h-4 mr-2 text-blue-600" data-id="element-283" />
                <span data-id="element-284">Dauer: 1 Tag</span>
              </div>
              <div className="flex items-center" data-id="element-285">
                <MapPin className="w-4 h-4 mr-2 text-blue-600" data-id="element-286" />
                <span data-id="element-287">Remote oder vor Ort</span>
              </div>
            </div>
            <p className="text-xl text-slate-600 leading-relaxed mb-4" data-id="element-288"></p>
            <button onClick={() => {
            const subject = encodeURIComponent('Anfrage: Individueller Schulungstermin');
            const body = encodeURIComponent(`Guten Tag,

ich interessiere mich für einen individuellen Schulungstermin für unser Team.

Anzahl Teilnehmer: 
Gewünschter Zeitraum: 
Bevorzugter Ort: 

Bitte kontaktieren Sie mich für weitere Details.

Mit freundlichen Grüßen`);
            window.location.href = `mailto:info@ellnerconsult.de?subject=${subject}&body=${body}`;
          }} className="inline-flex items-center text-blue-600 font-medium hover:text-blue-800 transition-colors" data-id="element-289">
              Individuellen Termin anfragen →
            </button>
          </div>

          {/* Calendar Section */}
          <div className="mb-20 bg-gradient-to-br from-blue-50 to-white rounded-2xl shadow-xl border-2 border-blue-200 p-8 lg:p-12" data-id="element-290">
            <div className="text-center mb-10" data-id="element-291">
              <h2 className="text-3xl font-bold text-slate-900 mb-3" data-id="element-292">
                Verfügbare Termine
              </h2>
              <p className="text-lg text-slate-600" data-id="element-293">
                Wählen Sie einen passenden Termin und buchen Sie direkt per
                E-Mail
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-294">
              {availableDates.map((slot, index) => {
              const isPast = isDateInPast(slot.date);
              const isFullyBooked = slot.spots === 0;
              const isBookable = !isPast && !isFullyBooked;
              const coursePrice = getCoursePrice(slot);
              const showOffer = isSpecialOffer(slot);
              return <div key={index} className={`rounded-xl p-6 border shadow-sm transition-shadow ${!isBookable ? 'bg-slate-100 border-slate-300 opacity-60' : 'bg-white border-slate-200 hover:shadow-md'}`} data-id="element-295">
                    <div className="flex items-start justify-between mb-6" data-id="element-296">
                      <div className={`flex items-center ${!isBookable ? 'text-slate-500' : 'text-blue-900'}`} data-id="element-297">
                        <Calendar className="w-5 h-5 mr-2" data-id="element-298" />
                        <span className="font-bold text-lg" data-id="element-299">{slot.date}</span>
                      </div>
                      {isPast ? <span className="text-xs bg-slate-200 text-slate-600 px-2 py-1 rounded-full" data-id="element-300">
                          Vergangen
                        </span> : isFullyBooked ? <span className="text-xs bg-orange-100 text-orange-700 px-2 py-1 rounded-full" data-id="element-301">
                          Ausgebucht
                        </span> : <span className="text-xs bg-green-100 text-green-700 px-2 py-1 rounded-full" data-id="element-302">
                          {slot.spots} Plätze frei
                        </span>}
                    </div>

                    <div className="space-y-2 mb-6" data-id="element-303">
                      <div className="flex items-center justify-between" data-id="element-304">
                        <div className={`flex items-center text-sm ${!isBookable ? 'text-slate-500' : 'text-slate-600'}`} data-id="element-305">
                          <Clock className="w-4 h-4 mr-2 text-slate-400" data-id="element-306" />
                          <span data-id="element-307">{slot.time}</span>
                        </div>
                        <div className="flex flex-col items-end gap-1" data-id="element-308">
                          {showOffer && isBookable && <span className="text-xs font-semibold text-orange-600 bg-orange-50 px-2 py-0.5 rounded" data-id="element-309">
                              Angebot
                            </span>}
                          <div className={`px-3 py-1.5 rounded-lg ${!isBookable ? 'bg-slate-200' : 'bg-gradient-to-br from-blue-600 to-blue-700'}`} data-id="element-310">
                            <div className={`text-sm font-bold leading-tight ${!isBookable ? 'text-slate-500' : 'text-white'}`} data-id="element-311">
                              {coursePrice}
                            </div>
                            <div className={`text-xs font-medium leading-tight ${!isBookable ? 'text-slate-400' : 'text-white opacity-90'}`} data-id="element-312">
                              + MwSt.
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center" data-id="element-313">
                        <div className={`flex items-center text-sm ${!isBookable ? 'text-slate-500' : 'text-slate-600'}`} data-id="element-314">
                          <MapPin className="w-4 h-4 mr-2 text-slate-400" data-id="element-315" />
                          <span data-id="element-316">{slot.location}</span>
                        </div>
                      </div>
                    </div>

                    <button onClick={() => isBookable && handleBooking(slot.date, slot.location, coursePrice)} disabled={!isBookable} className={`w-full font-medium py-3 px-4 rounded-lg transition-colors flex items-center justify-center ${!isBookable ? 'bg-slate-300 text-slate-500 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 text-white'}`} data-id="element-317">
                      <Mail className="w-4 h-4 mr-2" data-id="element-318" />
                      {isPast ? 'Termin vergangen' : isFullyBooked ? 'Ausgebucht' : 'Termin anfragen'}
                    </button>
                  </div>;
            })}
            </div>

            <div className="mt-8 text-center" data-id="element-319">
              <p className="text-slate-600 mb-4" data-id="element-320">
                Kein passender Termin dabei? Wir bieten auch individuelle
                Termine für Ihr Team an. Gerne auch auf Englisch oder bei Ihnen
                vor Ort
              </p>
              <button onClick={() => {
              const subject = encodeURIComponent('Anfrage: Individueller Schulungstermin');
              const body = encodeURIComponent(`Guten Tag,

ich interessiere mich für einen individuellen Schulungstermin für unser Team.

Anzahl Teilnehmer: 
Gewünschter Zeitraum: 
Bevorzugter Ort: 

Bitte kontaktieren Sie mich für weitere Details.

Mit freundlichen Grüßen`);
              window.location.href = `mailto:info@ellnerconsult.de?subject=${subject}&body=${body}`;
            }} className="inline-flex items-center text-blue-600 font-medium hover:text-blue-800 transition-colors" data-id="element-321">
                Individuellen Termin anfragen →
              </button>
            </div>
          </div>

          {/* Outro Section */}
          <div className="max-w-3xl mx-auto text-center bg-white p-10 rounded-2xl shadow-sm border border-slate-200" data-id="element-322">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-323">
              Noch Fragen zur Schulung?
            </h2>
            <p className="text-lg text-slate-600 mb-8" data-id="element-324">
              Kontaktieren Sie uns gerne für weitere Details zu Inhalten, Ablauf
              und Zertifizierung.
            </p>
            <button onClick={() => {
            window.location.hash = '#/';
            setTimeout(() => {
              const element = document.getElementById('contact');
              if (element) {
                element.scrollIntoView({
                  behavior: 'smooth'
                });
              }
            }, 100);
          }} className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-900 hover:bg-blue-800 transition-colors" data-id="element-325">
              Kontakt aufnehmen
            </button>
          </div>
        </div>
      </main>

      <Footer data-id="element-326" />
    </div>;
}